import { useHttp } from '@/plugins/http/src/index'
import { fromResp, PageQueryParams, PageResponse, toRequest } from '@/common/page-data'
import { cacheUrlRequest, generatorCacheId, cacheUrlGet } from '@/utils/urlUtils'
import _ from 'lodash'
import { convertColumnValue } from '@/api/commonService'
import dayjs from 'dayjs'

const baseApi = '/api/air8-financial-transaction/ar/management'
export function queryBuyerList(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryBuyerList', params)
}
export function queryBuyersByA8SupplierIds(params: any) {
  const { http } = useHttp()
  return http.post('/api/buyer-portal/api/rest/queryBuyersByA8SupplierIds', params)
}

export function queryOutlookByBuyerIds(params: any) {
  const { http } = useHttp()
  return http.post('/api/buyer-portal/api/rest/queryOutlookByBuyerIds', params)
}

export async function queryBuyerListCache(params: any) {
  const cacheId = generatorCacheId({ url: 'method://ar/queryBuyerList', params })
  return cacheUrlRequest(cacheId, () => queryBuyerList(params), 500)
}

export function queryBuyersByA8SupplierIdsCache(params: any) {
  const cacheId = generatorCacheId({ url: 'method://ar/queryBuyersByA8SupplierIds', params })
  return cacheUrlRequest(cacheId, () => queryBuyersByA8SupplierIds(params), 500)
}

export async function queryOutlookByBuyerIdsCache(params: { buyerIds: number[] }) {
  const cacheId = generatorCacheId({ url: 'method://ar/queryOutlookByBuyerIds', params })
  return cacheUrlRequest(cacheId, () => queryOutlookByBuyerIds(params), 500)
}

export function queryTradeInfoCount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryTradeInfoCount', params)
}

export async function queryTradeInfoCountCache(params: any) {
  const cacheId = generatorCacheId({ url: 'method://ar/queryTradeInfoCount', params })
  return cacheUrlRequest(cacheId, () => queryTradeInfoCount(params), 500)
}

export async function queryDueBalance(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryDueBalance', params)
}

export async function queryDueBalanceCount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryDueBalanceCount', params)
}

export async function queryDueBalanceCountCache(params: any) {
  const cacheId = generatorCacheId({ url: 'method://ar/queryDueBalanceCount', params })
  return cacheUrlRequest(cacheId, () => queryDueBalanceCount(params), 500)
}

export async function queryHistoryDueBalance(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryHistoryDueBalance', params)
}

export function querySalesCount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/querySalesCount', params)
}

export async function querySalesList(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/querySalesList', params)
}

export function queryDueBalanceTable(params: any) {
  const { http } = useHttp()
  return fromResp(http.post<PageResponse<any>>(baseApi + '/queryDueBalanceTable', toRequest(params)))
}

export function querySalesTable(params: any) {
  const { http } = useHttp()
  return fromResp(http.post<PageResponse<any>>(baseApi + '/querySalesTable', toRequest(params)))
}

export async function queryCurrencyList() {
  const { http } = useHttp()
  return http.get(baseApi + '/queryCurrencyList')
}

export function queryPendingTask(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryPendingTask', params)
}

export function queryBuyerCodeList() {
  const { http } = useHttp()
  return http.get(baseApi + '/queryBuyerCodeList')
}

export function queryAccountReceivableByBuyer(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryAccountReceivaleByBuyer', params)
}

export function queryPaymentHistoryByBuyer(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryPaymentHistoryByBuyer', params)
}

export function queryDilutionByBuyer(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryDilutionByBuyer', params)
}

export function queryDilutionByDate(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryDilutionByDate', params)
}

export function queryPaymentHistoryByDate(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryPaymentHistoryByDate', params)
}

export function queryAccountReceivaleByDate(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryAccountReceivaleByDate', params)
}

export function queryFinancingBalanceAmount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryFinancingBalanceAmount', params)
}

export function queryRepaymentDueInNext7DaysAmount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryRepaymentDueInNext7DaysAmount', params)
}

export function availableForFinanceAmount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/availableForFinanceAmount', params)
}

export function queryPaymentHistoryTable(params: any) {
  const { http } = useHttp()
  return fromResp(http.post<PageResponse<any>>(baseApi + '/queryPaymentHistoryTable', toRequest(params)))
}

export function queryDilutionByBuyerTable(params: any) {
  const { http } = useHttp()
  return fromResp(http.post<PageResponse<any>>(baseApi + '/queryDilutionByBuyerTable', toRequest(params)))
}

export function queryDilutionByDateTable(params: any) {
  const { http } = useHttp()
  return fromResp(http.post<PageResponse<any>>(baseApi + '/queryDilutionByDateTable', toRequest(params)))
}

export async function queryTariffMapping() {
  // todo
  const { http } = useHttp()
  const url = '/api/buyer-portal/api/rest/queryTariffConfig'
  const result = await cacheUrlGet(http, url, undefined, undefined, 500)
  return _.get(result, 'v_tariff_conf')
}

/* -------------------------- start --------------------------------- */
const COLUMN_TYPE = {
  DATE_TIME: 'dateTime',
  ARRAY: 'array'
}
export const NEWS_SIGNAL_TABLE_COLUMNS = {
  NEWS_DATE: 'news_date',
  TOPICS: 'topics',
  VTOPIC: 'vtopic',
  TEXT: 'text'
}

const PORTAL_ARTICLES_TABLE_COLUMNS_TYPE = {
  [NEWS_SIGNAL_TABLE_COLUMNS.NEWS_DATE]: COLUMN_TYPE.DATE_TIME,
  [NEWS_SIGNAL_TABLE_COLUMNS.VTOPIC]: COLUMN_TYPE.ARRAY
}

const PORTAL_ARTICLES_TABLE_COLUMNS = {
  ...NEWS_SIGNAL_TABLE_COLUMNS,
  REGION: 'region',
  TAGS: 'tags',
  THUMBNAIL: 'thumbnail',
  VTOPIC: 'vtopic'
}
/* -------------------------- end --------------------------------- */
export async function marketInsights(params: { regionIn: string[] }) {
  const { http } = useHttp()
  const data = ['Global', ...params.regionIn]
  const result = await http.post('/api/buyer-portal/api/rest/marketInsights/newsPanelList')
  // temp remove body since we have daily news structure without region {
  //   region_in: data
  // }
  return _.map(_.get(result, 'buyers_daily_news_rel'), (k: any) => {
    const tags = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS)
    const topics = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.TOPICS)
    const vtopic = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS, tags ? _.split(tags, ',') : null)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.TOPICS, topics ? _.split(topics, ',') : null)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC, vtopic ? vtopic.replace(/'/g, '') : null)
    return convertColumnValue(k, PORTAL_ARTICLES_TABLE_COLUMNS_TYPE)
  })
}

export async function buyerMarketInsights(params: { brandListId: number[]; newsDate: string }) {
  const { http } = useHttp()
  const result = await http.post('/api/buyer-portal/api/rest/newsSignals/queryByBuyerIdListNew', params)
  return _.map(_.get(result, 'buyers_daily_news_rel'), (k: any) => {
    const tags = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS)
    const topics = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.TOPICS)
    const vtopic = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS, tags ? _.split(tags, ',') : null)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.TOPICS, topics ? _.split(topics, ',') : null)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC, vtopic ? vtopic.replace(/'/g, '') : null)
    return convertColumnValue(k, PORTAL_ARTICLES_TABLE_COLUMNS_TYPE)
  })
}

// air8 market insight is in table portal_articles
export async function queryAir8MarketInsightById(params: { id: number }) {
  const { http } = useHttp()
  const result = await http.post('/api/buyer-portal/api/rest/newsSignals/queryAir8MarketInsightById', params)
  return _.map(_.get(result, 'portal_articles'), (k: any) => {
    const tags = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS)
    const vtopic = _.get(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.TAGS, tags ? _.split(tags, ',') : null)
    _.set(k, PORTAL_ARTICLES_TABLE_COLUMNS.VTOPIC, vtopic ? vtopic.replace(/'/g, '') : null)
    return convertColumnValue(k, PORTAL_ARTICLES_TABLE_COLUMNS_TYPE)
  })
}

export function queryDilutionCount(params: any) {
  const { http } = useHttp()
  return http.post(baseApi + '/queryDilutionCount', params)
}
